import AsyncStorage from '@react-native-async-storage/async-storage';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import { apiConteudoSlice } from 'services/apiConteudo';
import { backendApiSlice } from 'services/backend';
import { cmsApiSlice } from 'services/cms';
import { mediaApiSlice } from 'services/media';
import { Platform } from 'utils/platform';

import authReducer from './slices/authSlice';
import boomarksReducer from './slices/boomarkSlice';
import deepLinkingSlice from './slices/deepLinkingSlice';
import profileReducer from './slices/profileSlice';
import ratingSlice from './slices/ratingSlice';
import userDeviceSessionDataReducer from './slices/userDeviceSessionData';

const profilePersistConfig = {
  key: 'profile',
  storage: AsyncStorage,
  ...(Platform.isTV ? { blacklist: ['selectedProfileId'] } : {}),
};

const persistConfig = {
  key: 'root',
  storage: AsyncStorage,
  whitelist: ['auth', 'bookmarks', 'rating', 'userDeviceData', 'deepLinking'],
};

const rootReducer = combineReducers({
  auth: authReducer,
  profile: persistReducer(profilePersistConfig, profileReducer),
  bookmarks: boomarksReducer,
  rating: ratingSlice,
  userDeviceData: userDeviceSessionDataReducer,
  deepLinking: deepLinkingSlice,
  [backendApiSlice.reducerPath]: backendApiSlice.reducer,
  [cmsApiSlice.reducerPath]: cmsApiSlice.reducer,
  [apiConteudoSlice.reducerPath]: apiConteudoSlice.reducer,
  [mediaApiSlice.reducerPath]: mediaApiSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      backendApiSlice.middleware,
      cmsApiSlice.middleware,
      apiConteudoSlice.middleware,
      mediaApiSlice.middleware
    ),
});

export const persistor = persistStore(store);
